import { render } from "./CrudModeloVeiculoTrator.vue?vue&type=template&id=b88e1f84"
import script from "./CrudModeloVeiculoTrator.vue?vue&type=script&lang=ts"
export * from "./CrudModeloVeiculoTrator.vue?vue&type=script&lang=ts"
script.render = render

export default script